import { render, staticRenderFns } from "./flowPoolDetail.vue?vue&type=template&id=14815084&scoped=true&"
import script from "./flowPoolDetail.vue?vue&type=script&lang=js&"
export * from "./flowPoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./flowPoolDetail.vue?vue&type=style&index=0&id=14815084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14815084",
  null
  
)

export default component.exports